import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

// FETCH FLOAT TYPE LIST
export const fetchPettyCashFloatTypeList = createAsyncThunk("fetchPettyCashFloatTypeList", async (_, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`/category/list?categoryType=Petty Cash Floats&page=1&limit=100`);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const PettyCashFloatTypeListSlice = createSlice({
	name: "PettyCashFloatTypeListSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetFloatTypeListState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPettyCashFloatTypeList.pending, (state, action) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(fetchPettyCashFloatTypeList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(fetchPettyCashFloatTypeList.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetFloatTypeListState } = PettyCashFloatTypeListSlice.actions;
export default PettyCashFloatTypeListSlice.reducer;
